import AppAction from "@my-dld/actions";
import { Action } from "redux";
import { EjariProperty } from "@eres/ejari-api/Entity";
import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import { LocaleValue } from "@eres/core/dist/LocaleValue";

export interface EjariDataState {
	tabuLink?: {
		propertyId: number;
		propertyType: number;
		isFreeHold: boolean;
	};
	tabuProperty?: AssetCard;
	property?: EjariProperty;
	lastPropertyTime: number;
	activeUserId?: number;
	isRefreshing?: boolean;
	userType: EjariUserType;
	breadcrumbs?: {
		id: string,
		label: LocaleValue,
		link: string,
	}[];
}

export type EjariUserType = "owner" | "mc" | "tenant";

export const defaultState: EjariDataState = {
	userType: "owner",
	lastPropertyTime: 0,
};

export enum EjariDataAction {
	EJARI_CLEAR_DATA = "EJARI_CLEAR_DATA",
	EJARI_UPDATE_PROPERTY = "EJARI_UPDATE_PROPERTY",
	EJARI_UPDATE_STATE = "EJARI_UPDATE_STATE",
}

export type EjariAction =
	Action<AppAction.USER_LOGGED_OUT> |
	Action<EjariDataAction.EJARI_CLEAR_DATA> |
	Action<EjariDataAction.EJARI_UPDATE_PROPERTY> & { payload?: EjariProperty } |
	Action<EjariDataAction.EJARI_UPDATE_STATE> & { payload?: Partial<EjariDataState> };

export function EjariDataReducer( state = defaultState, action: EjariAction ) {
	switch ( action.type ) {
		case EjariDataAction.EJARI_CLEAR_DATA:
			return {
				...defaultState
			};
		case EjariDataAction.EJARI_UPDATE_PROPERTY:
			return {
				...state,
				property: action.payload,
			};
		case EjariDataAction.EJARI_UPDATE_STATE:
			return {
				...state,
				...action.payload,
			};

		case AppAction.USER_LOGGED_OUT:
			return { ...defaultState };
		default:
			return state;
	}
}
